import { User } from './user';
import { Commodity } from './commodity';
import { Warehouse } from './warehouse';

export class CommodityWarehouse {
  commodity_uuid!: string;
  warehouse_uuid!: string;
  status!: string;
  user_uuid!: string;
  date_deleted?: number;
  uuid!: string;
  date_created!: number;
  date_updated!: number;

  user?: User;
  commodity?: Commodity;
  warehouse?: Warehouse;

  static getSortColumns() {
    return ['status'];
  }

  constructor(data: any) {
    this.commodity_uuid = data.commodity_uuid;
    this.warehouse_uuid = data.warehouse_uuid;
    this.status = data.status;
    this.user_uuid = data.user_uuid;
    this.date_deleted = data.date_deleted;
    this.uuid = data.uuid;
    this.date_created = data.date_created;
    this.date_updated = data.date_updated;

    if (data.user) {
      this.user = new User(data.user);
    }
    if (data.commodity) {
      this.commodity = new Commodity(data.commodity);
    }
    if (data.warehouse) {
      this.warehouse = new Warehouse(data.warehouse);
    }
  }
}
